import LiveApi from '@/api/live';
import {jsonToQuerystring} from '@/utils/main';

/**
 * API 서버로 부터 별별랭킹 정보를 가져온다.
 * @param {number} nCount - 랭크 테마 별 가져올 방송 수
 * @returns @type { {themeData, bestDataCnt, bestData} }
 */
export const getStarRankData = async (nCount) => {
  const {data} = await LiveApi.post(
    '/api/star_rank.php',
    jsonToQuerystring({szWork: 'getStarRank', nCount}),
  );

  return data;
};
